<template>
  <div class="container-fluid">

    <div class="pt-5 row d-none d-lg-flex full-height">
      <div class="d-none d-lg-block col-md-3">
        <side-menu :showInfoTv="showInfoTv" :tv="currTv" :currentProgram="infoCurrentProgram" :futureProgram="futureProgram"/>
      </div>
      
      <div class="col-lg-9 col-md-12">
        
        <div class="row d-flex align-items-stretch justify-content-center">

          <div class="col-md-5 text-left">
            <div class="row align-items-center">
              <div class="d-none d-lg-block col-3">
                <img src="../assets/images/icona_live_tv.png" class="img-fluid"  > 
              </div>
              <div class="col pt-2">
                <span class="text-white" id="text_logo">LIVE TV</span><br>
                <span id="text">Canali in Streaming</span>
              </div>

            </div>

          </div>
          <div class="d-none d-md-flex col-md-7 align-items-center justify-content-end">
            <div class="w-100">
              <search :back="true" :backlink="this.backlink"></search>  
            </div> 
          </div>

          
        </div>
        <div class="row pt-5" style="margin-bottom:6rem;">
          <div class="col-md-5 align-items-start">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key">
            <div class="col-md-12" v-if="index < (tv.length / 2)" @mouseover="mouseOver(item)" @mouseout="mouseOut()">
                <router-link :to="`/show/${item.search_key}`">
                  <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero" ></tv-card>
                  
                </router-link>
                </div>                
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key" @mouseover="mouseOver(item)" @mouseout="mouseOut()">
              <div class="col-md-12"  v-if="index >= (tv.length / 2)">
                  <router-link class="tv-link" :to="`/show/${item.search_key}`" >
                    <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero"></tv-card>
                    
                  </router-link>
                </div>
            </div>
          </div>
        </div>
        <footer class="navbar footer navbar-trasparent text-center px-5">
          <main-footer />
        </footer>
      </div>
    </div>
    <!-- NOD. RESPONSIVE -->
    <div class="row d-lg-none d-md-flex" style="height:700px;">
      <div class="col-12">
        <div class="row d-flex align-items-stretch justify-content-center">
          <div class="col-12 pt-4 align-items-center justify-content-end pb-3">
            <search :back="true" :backlink="this.backlink"></search>   
          </div>
          <div class="col-md-12 text-left">
            <div class="row align-items-center">
              <div class="pl-3">
                <img src="../assets/images/icona_live_tv_sm.png" class="img-fluid"  > 
              </div>
              <div class="col pt-2">
                <span class="text-white" id="text_logo">LIVE TV</span><br>
                <span id="text">Canali in Streaming</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-5">
          
          <div class="col-md-5 align-items-start">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key">
            <div class="col-md-12" v-if="index <= (tv.length / 2)">
                <router-link :to="`/show/${item.search_key}`">
                  <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero" ></tv-card>
                  
                </router-link>
                </div>                
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key" >
              <div class="col-md-12"  v-if="index > (tv.length / 2)" >
                  <router-link class="tv-link" :to="`/show/${item.search_key}`" >
                    <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero"></tv-card>
                    
                  </router-link>
                </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="navbar footer navbar-trasparent text-center px-5">
        <main-footer />
      </footer>
    </div>
    
    <!-- <footer class="navbar footer navbar-trasparent text-center pt-5">
        <div class="row width-100">
          <div class="col-md-12 d-none d-md-flex align-items-center justify-content-end">
            <router-link to="/" class="navbar-brand">
                &nbsp;&nbsp;<img src="../assets/images/logo.png" />
            </router-link>
          </div>
        </div>
    </footer>  -->         
  </div>  
</template>

<script>
// @ is an alias to /src

import TvCard from '@/components/TvCard.vue'
import Tv from '../api/tv.js';
import SideMenu from '@/components/SideMenu.vue'
import MainFooter from '@/components/MainFooter.vue'
import Epg from '../models/Epg.js';
import Search from '@/components/Search.vue'
//import { mapState, mapActions, mapGetters } from 'vuex'
import { mapState } from 'vuex'

export default {
  name: 'list',
  data: function() {
    return  {
      tv: [],
      backlink: "javascript:history.go(-1)",
      currTv: {
          imageUrl: "",
          sigla: "",
          numero: "",
          favorite: false,
        },
      infoCurrentProgram: {
          descrizione: "",
          start: "",
          end: "",
          title: ""
        },
      futureProgram: [], 
      showInfoTv: false 
    };
  },
  components: {
    TvCard,SideMenu,Search,MainFooter
  },
  computed: {    
    ...mapState({
        user: state => state.User
    }),
  },
  methods: { 
      mouseOver(item) {    
        this.showInfoTv = true;
        let epg = new Epg(item);
        this.currTv = item;
        this.futureProgram = epg.getFutureProgram();
        this.infoCurrentProgram = epg.getCurrentProgram();
      },
      mouseOut() { 
        this.showInfoTv = false;        
      },
  },
  created: function() {
      this.backlink = window.history.state == null ? "/" : this.backlink;
      let searchKey = this.$route.params.search_key;
      //console.log(searchKey)
      let apiTv = new Tv();
      apiTv.getFilterTv(searchKey)
        .then(response => {
          //console.log(response.data)
          if(response.data) {
            this.tv = response.data;
          } else {
            console.log("Nessun dato ricevuto");
          }
        })
        .catch(function (error) {
              console.log(error);                       
        });
      //console.log(this.user);
  }
}
</script>

<style scoped lang="scss">

#text_logo{
    font-weight:bold;
    font-size:36px;
}

#text{
  font-size:20px;
  font-weight:normal;
  color: #ddd;
}


</style>